import React from "react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from '@material-ui/core/CssBaseline';

const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      light:"#6d6d6d",
      main: "#003C41",
      dark: "#1b1b1b",
      contrastText: "#fafafa",
    },
    secondary: {
      light: "#62eaff",
      main: "#00b7d3",
      dark: "#0087a2",
      contrastText: "#fafafa",
    },
    background:{
      default:"#eaeaea"
    }
    
  },
});

const ApplicationTheme = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
};

export default ApplicationTheme;
